import script from "./ImageCarousel.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImageCarousel.vue?vue&type=script&setup=true&lang=ts"

import "./ImageCarousel.vue?vue&type=style&index=0&id=e4d34e4e&lang=css"
import "./ImageCarousel.vue?vue&type=style&index=1&id=e4d34e4e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e4d34e4e"]])

export default __exports__